import { AnyAction, Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import _ from 'underscore';
import { PushNotification, PushNotificationState, PushNotificationTypes, PushNotificationViewData } from './types';

const initialStatePushNotificationList: PushNotificationViewData = {
    list: [] as PushNotification[],
    total: 0,
};

const INITIAL_STATE: PushNotificationState = {
    data: {
        listAllPushNotification: { ...initialStatePushNotificationList },
        listUncheckedPushNotification: { ...initialStatePushNotificationList },
    },
    loading: false,
    hasError: false,
};

const processPushNotificationRequestSuccess = (state: PushNotificationState, action: AnyAction, listKey: string) => {
    const currentList: PushNotification[] = [...state.data[listKey].list];
    const newList: PushNotification[] = [...action.payload.data];
    const mergedlist: PushNotification[] = currentList.concat(newList);
    const resultList: PushNotification[] = (_.chain(mergedlist)
        .filter((pushNotification: PushNotification) => Boolean(pushNotification.id))
        .uniq(false, (pushNotification: PushNotification) => pushNotification.id)
        .value() as unknown) as PushNotification[];

    return {
        ...state,
        loading: false,
        hasError: false,
        data: {
            ...state.data,
            [listKey]: {
                ...state.data[listKey],
                list: resultList,
                total: action.payload.total,
                loading: false,
            },
        },
    };
};

const reducer: Reducer<PushNotificationState> = (state: PushNotificationState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS:
            return {
                ...state,
                loading: true,
                hasError: false,
            };
        case PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS_SUCCESS:
            const oldUncheckedList = [...state.data.listUncheckedPushNotification.list];
            const oldAllList = [...state.data.listAllPushNotification.list];
            const newUncheckedList = oldUncheckedList.filter((notification: PushNotification) => notification.id !== action.payload);
            const newAllList = oldAllList.map((notification: PushNotification) =>
                notification.id === action.payload ? { ...notification, checked: true } : notification,
            );

            return {
                ...state,
                data: {
                    ...state.data,
                    listUncheckedPushNotification: {
                        ...state.data.listUncheckedPushNotification,
                        list: newUncheckedList,
                        total: state.data.listUncheckedPushNotification.total - 1,
                        loading: false,
                    },
                    listAllPushNotification: {
                        ...state.data.listAllPushNotification,
                        list: newAllList,
                        loading: false,
                    },
                },
                loading: false,
                hasError: false,
            };
        case PushNotificationTypes.UPDATE_PUSH_NOTIFICATION_STATUS_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
            };
        case PushNotificationTypes.GET_PUSH_NOTIFICATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                hasError: false,
            };
        case PushNotificationTypes.ALL_PUSH_NOTIFICATION_LIST_SUCCESS:
            return processPushNotificationRequestSuccess(state, action, 'listAllPushNotification');
        case PushNotificationTypes.UNCHECKED_PUSH_NOTIFICATION_LIST_SUCCESS:
            return processPushNotificationRequestSuccess(state, action, 'listUncheckedPushNotification');
        case PushNotificationTypes.GET_PUSH_NOTIFICATION_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                hasError: true,
            };

        case PushNotificationTypes.CLEAR_UNCHECKED_NOTIFICATIONS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, listUncheckedPushNotification: { ...initialStatePushNotificationList } },
            };
        case PushNotificationTypes.CLEAR_ALL_NOTIFICATIONS:
            return {
                ...state,
                loading: false,
                hasError: false,
                data: { ...state.data, listAllPushNotification: { ...initialStatePushNotificationList } },
            };
        default:
            return state;
    }
};

export default reducer;
